/** Profile content shared by About's bento grid and its scroll scene. Edited at /admin. */
import profile from "../content/profile.json";

export const SKILLS: string[] = profile.skills;

export const BIO: { label: string; heading: string; body: string } = profile.bio;

export const LOCATION: { country: string; lat: number; lon: number } = profile.location;

export const GITHUB_USER: string = profile.githubUser;
